import FieldLabel from "common-form/components/FieldLabel";
import {LABEL_TYPE} from "../../../../../form/components/Field";
import * as React from "react";
import QuestionBlock from "../../../../../form/QuestionBlock";
import FieldRadioYesNo from "common-form/components/FieldRadioYesNo";
import {FIELDS} from "common-hypotheca";
import {Alert} from "../../../../../form/components";
import {ALERTTYPE} from "../../../../../form/components/alert/Alert";

export default function OtherMortgageAnalysis(parent, nextQuestionId) {

    function wantsReview() {
        return parent.getField(FIELDS.MA.SSI.DoIWantOtherMortgagesReview).value === true;
    }

    return {
        block: (params) =>
            <QuestionBlock {...params}>

                <FieldLabel
                    label="Do you want to see current deals for your other mortgages?"
                />

                <FieldLabel
                    label="A free service to review and present current deals for your residential, buy to let or other mortgages."
                    labelType={LABEL_TYPE.Description}
                />

                <FieldRadioYesNo
                    labelType={LABEL_TYPE.Small}
                    {...parent.getField(FIELDS.MA.SSI.DoIWantOtherMortgagesReview)}
                />

                <Alert
                    text="Thank you for letting us know. Your advisor will be in touch shortly."
                    show={wantsReview()}
                    type={ALERTTYPE.SUCCESS}
                />

            </QuestionBlock>,
        validate: (context) => {
            context
                .mandatory(FIELDS.MA.SSI.DoIWantOtherMortgagesReview);
        },
        nextQuestionId: () => nextQuestionId
    };
}